import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import './Market.css';
import './Currency.css';
import './Commodity.css';
import { useParams } from "react-router-dom";
import Slider from 'react-slick';
import Newlisting from "./Newlisting/Newlisting";
import Iponews from "./Iponews/Iponews";
import IpoReturns from "./IpoReturns/IpoReturns";
import CurrencyFAQ from "../AllProducts/CurrencyProduct/CurrencyFAQ/CurrencyFAQ";
import CommoditiesFAQ from "../AllProducts/CommoditiesProduct/CommoditiesFAQ/CommoditiesFAQ";
import Ipowatch from "./Ipowatch/Ipowatch";
import Bestperformers from "./Bestperformers/Bestperformers";
import Basisofallotment from "./Basisofallotment/Basisofallotment";
import Draftprospectus from "./Draftprospectus/Draftprospectus";
import marketup from '../../Images/arrow-up.png';
import marketdown from '../../Images/Images/arrow-down.png';
import commodity_image from '../../Images/commodity_image.png';
import course from '../../Images/Currency/course-title-img.svg'
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../utils/useLocalStorage";
import demat from '../../Images/Currency/demat-img.svg'
import Pagination from "../CommonUI/Pagination/Pagination";
import MarketEquity from "../MarketEquity/MarketEquity";
import CorporateActMar from "./CorporateActMar/CorporateActMar";
import { Modal } from "react-bootstrap";
import { Vortex } from 'react-loader-spinner'
import { format, parseISO } from 'date-fns';
import learn from '../../Images/Currency/learn-icon.svg'
import sensibullmblimg from '../../Images/Currency/sensibull-mbl-img.svg';
import ipograph from '../../Images/ipo-graph.png';
import mfgraph from '../../Images/mf-graph.png';
import commoditybanner from '../../Images/Currency/commodity-trading-banner.png';
import commoditybannerNew from '../../Images/Currency/CommodityBannerNew.png';
import highliquidity from '../../Images/Currency/high-liquidty.svg';
import tradeanywhere from '../../Images/Currency/trade-from-anywhere-icon.svg';
import learnicon from '../../Images/Currency/learn-icon.svg';
import decisionicon from '../../Images/Currency/descision-icon.svg';
import descision from '../../Images/Currency/descision-icon.svg'
import lowcost from '../../Images/Currency/low-cost-icon.svg';
import sensibull from '../../Images/Currency/sensibull.svg';
import sensibull1 from '../../Images/Currency/sensibull-trangle-1.svg';
import sensibull2 from '../../Images/Currency/sensibull-trangle-2.svg';
import sensibullcircle1 from '../../Images/Currency/sensibull-circle-1.svg';
import sensibullcircle2 from '../../Images/Currency/sensibull-circle-2.svg';
import dematimg from '../../Images/Currency/demat-img.svg';
import filldetail from '../../Images/Currency/fill-in-details.svg';
import uploaddoc from '../../Images/Currency/upload-documents.svg';
import starttrading from '../../Images/Currency/start-trading.svg';
import docimg from '../../Images/Currency/upload-document-img.svg';
import checkedcircle from '../../Images/Currency/checked-circle.svg';
import MarketMF from "../MutualFund/MarketMF";
import MarketIPO from "../IPO/MarketIPO";
import MarketFandO from "../MarketFandO/MarketFandO";
import diversification from '../../Images/Currency/diversification-icon.svg';
import { Portal } from "@material-ui/core";
import IPOCard from "./IPOCard/IPOCard";
import MfDividend from '../Market/MfLanding/MfDividend'
import MutualFundnews from "../Market/MfLanding//MutualFundnews";
import MfWhatsInOut from "../Market/MfLanding/MfWhatsInOut";
import MfNewFundOffer from "../Market/MfLanding/MfNewFundOffer";
import MfFundPerformance from "../Market/MfLanding/MfFundPerformance";
import MfNav from "../Market/MfLanding/MfNav";
import MFActivitiChart from "../Market/MfLanding/MFActivitiChart";
import MfCardNFO from "../Market/MfLanding/MfCardNFO";
import MfFundProfile from "../Market/MfLanding/MfFundProfile";
import MfTopHoldings from "../Market/MfLanding/MfTopHoldings";
import MfActivity from "../Market/MfLanding/MfActivity";
import FandOPutCallRatio from "../Market/FandOPutCallRatio/FandOPutCallRatio";
import FandOFIIStatistics from "../Market/FandOFIIStatistics/FandOFIIStatistics";
import FandOMostAttractiveContracts from "../Market/FandOMostAttractiveContracts/FandOMostAttractiveContracts";
import FandOTodaysMarket from "../Market/FandOTodaysMarket/FandOTodaysMarket";
import FandOCard from "../Market/FandOCard/FandOCard";
import OptionChains from "../Market/OptionChains";
import ETFProduct from "../AllProducts/ETFProduct/ETFProduct";
import HighLowOpenIntrest from "../Market/HighLowOpenIntrest";
import DerivativesNewsFandO from "../Market/DerivativesNewsFandO";
import StockCard from "./StockCard/StockCard";
import { isMatchWithOptions } from "date-fns/fp";
import CurrencyTable from "./CurrencyTable";
import CommodityTable from "./CommodityTable";
import Calendar from "./Calender/Calender";
import SGBPage from "./SGB/SGBPage";
import TrackApi from "../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";

function Market(props) {
  const [cookies, setCookie] = useCookies(['LeadId']);

    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [key, setKey] = useState('stocks');
    const [dataLoose, setDataLoose] = useState([]);
    const [dataIndex, setDataIndex] = useState([]);
    const [dataNews, setDataNews] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataWatch, setDataWatch] = useState([]);
    const [dataActive, setDataActive] = useState([]);
    const [dataCap, setDataCap] = useState([]);
    const [dataTicker, setDataTicker] = useState([]);
    const [loadingshowindex, setloadingshowindex] = useState(false);
    const [loadingshowactive, setloadingshowindexactive] = useState(false);
    const [loadingshowgainer, setloadingshowindexagainer] = useState(false);
    const [loadingshownews, setloadingshowindexnews] = useState(false);
    const [loadingshowloser, setloadingshowindexloser] = useState(false);
    const { tabName } = useParams();
    const [valuebtn, setValueBtn] = useState("NSE");
    const [activeTab, setActiveTab] = useState([]);
    const [loadingshowmarketcap, setloadingshowmarketcap] = useState(false);
    const [loadingshowtable, setloadingshowtable] = useState(false);
    const [show, setShow] = useState(false);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let getDataWatch;
    let getData, getDataLoose, getDataIndex, getDataTicker,
        getDataActive, getDataNews, getDataCap, getDataActivites, getDataHolding, getDataHoldingdrop,
        getDataHoldingdropcat, getDataHoldingdropSheme,
        getDataHoldingdropFundDivi, getDataHoldingdropCatDivi, getDataHoldingdropShemeDivi, getDataHoldingDividend;

    let navigate = useNavigate();
    let PageSize = 5;
    const moreContent = () => {
        navigate("/MarketEquity/Gainers-and-Losers");
    }
    const moreNews = () => {
        navigate("/CompanyNews/Stock-Alert");
    }
    useEffect(() => {
        setloadingshowindex(true);
        setloadingshowindexactive(true);
        setloadingshowindexagainer(true);
        setloadingshowindexnews(true);
        setloadingshowindexloser(true);
        setloadingshowmarketcap(true);
        window.scrollTo(0, 0)
        const getUrlIndex = BaseURL + "Index";
        fetch(`${getUrlIndex}`)
            .then((response) => response.json())
            .then((dataI) => {
                getDataIndex = dataI.data;
                setDataIndex(getDataIndex);
                setloadingshowindex(false);
                //console.log(getDataIndex, "getDataIndex")
            })
            .catch((error) => {
            });

        const getUrlAct = BaseURL + "MostActive";
        fetch(`${getUrlAct}/NSE/-/10`)
            .then((response) => response.json())
            .then((dataA) => {
                getDataActive = dataA.data;
                setDataActive(getDataActive);
                setloadingshowindexactive(false);
                //console.log(getDataActive, "getDataActive")
            })
            .catch((error) => {
            });

        const getUrl = BaseURL + "TopGainersAndLosers";
        fetch(`${getUrl}/NSE/NIFTY/GAIN/10`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshowindexagainer(false);
                //console.log(getData, "getData")
            })
            .catch((error) => {
            });

        const getUrlNews = BaseURL + "LiveNews";
        fetch(`${getUrlNews}/10`)
            .then((response) => response.json())
            .then((dataN) => {
                getDataNews = dataN.data;
                setDataNews(getDataNews);
                setloadingshowindexnews(false);
                // console.log(getDataNews, "getDataNews")
            })
            .catch((error) => {
            });

        const getUrlLoose = BaseURL + "TopGainersAndLosers";
        fetch(`${getUrlLoose}/NSE/NIFTY/lose/10`)
            .then((response) => response.json())
            .then((dataL) => {
                getDataLoose = dataL.data;
                setDataLoose(getDataLoose);
                setloadingshowindexloser(false);
                //console.log(getDataLoose, "getDataLoose")
            })
            .catch((error) => {
            });

        const getUrlCap = BaseURL + "MarketCap";
        fetch(`${getUrlCap}/NSE/NIFTY/-/-`)
            .then((response) => response.json())
            .then((dataMC) => {
                getDataCap = dataMC.data;
                setDataCap(getDataCap);
                setloadingshowmarketcap(false);
                //console.log(getDataCap, "getDataCap")
            })
            .catch((error) => {
            });

        if (tabName === "event-tracker") {
            setActiveTab("eventTracker")
        }
        if (tabName === "stocks") {
            setActiveTab("stocks")
        }
        if (tabName === "ipo") {
            setActiveTab("ipo");
        }
        if (tabName === "currency") {
            setActiveTab("currency")
        }
        if (tabName === "mutual-funds") {
            setActiveTab("mutualfund")
        }
        if (tabName === "futures-and-options") {
            setActiveTab("fando")
        }
        if (tabName === "commodity") {
            setActiveTab("commodity")
        }
        if (tabName === "etf") {
            setActiveTab("etf")
        }
        if (tabName === "sgb") {
            setActiveTab("sgb")
        }

    }, []);

    useEffect(() => {
        setloadingshowtable(true);
        const getUrlTicker = BaseURL + "TickerTape";
        fetch(`${getUrlTicker}/${valuebtn}`)
            .then((response) => response.json())
            .then((dataTT) => {
                getDataTicker = dataTT.data;
                setDataTicker(getDataTicker);
                setloadingshowtable(false);
                // setloadingshow(false);
                //console.log(getDataTicker, "getDataTicker")
            })
            .catch((error) => {
            });

    }, [valuebtn]);

    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '').replace(/\./g, '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };

    const currentTableData = useMemo(() => {
        if (dataCap != null && dataCap != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (dataCap != null && dataCap != []) {
                if (dataCap.length > 0) {
                    return dataCap.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, dataCap]);

    const trackDatamarket=(id,url,pagename)=>{
        const payloadData={
          "RelatedProspectId":id,
          "ActivityNote": `${pagename} page visit`,
          "mx_Custom_1": pagename,
          "mx_Custom_2": "",
          "mx_CustomObject_81":url
         }
         TrackApi(payloadData);
      }
const accordiantrack=(url,pagename)=>{
    if(cookies && cookies.RelatedProspectId){
        trackDatamarket(cookies.RelatedProspectId,url,pagename);
      }  
    }
    const handleChange = (k) => {
        setKey(k);
        if(k === "eventTracker") {
            navigate("/market/event-tracker");
            accordiantrack(`${window.location.href}`,"Market Event Tracker")
        }
        if(k === "stocks") {
            navigate("/market/stocks");
            accordiantrack(`${window.location.href}`,"Market Stocks")

        }
        if(k === "ipo") {
            navigate("/market/ipo");
            accordiantrack(`${window.location.href}`,"Market IPO")
        }
        if(k === "mutualfund") {
            navigate("/market/mutual-funds");
            accordiantrack(`${window.location.href}`,"Market Mutual Fund")

        }
        if(k === "fando") {
            navigate("/market/futures-and-options");
            accordiantrack(`${window.location.href}`,"Market Futures And Options")
        }
        if(k === "currency") {
            navigate("/market/currency");
            accordiantrack(`${window.location.href}`,"Market Currency")

        }
        if(k === "commodity") {
            navigate("/market/commodity");
            accordiantrack(`${window.location.href}`,"Market Commodity")

        }
        if(k === "etf") {
            navigate("/market/etf");
            accordiantrack(`${window.location.href}`,"Market ETF")
        
        }
        if(k === "sgb") {
            navigate("/market/sgb");
            accordiantrack(`${window.location.href}`,"Market SGB")
        
        }
      };

    const settings = {
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    // autoplay: true,
                    // autoplaySpeed: 2000,
                },
            },
            {
                breakpoint: 481,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ]
    }
    const active = {
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 481,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ]
    }
    const gainer = {
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 481,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ]
    }
    const news = {
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 481,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ]
    }
    const loser = {
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 481,
                settings: {
                    dots: false,
                    infinite: true,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ]
    }

    useEffect(() => {
        window.addEventListener("scroll", handleScrollStock);
        return () => {
            window.removeEventListener("scroll", handleScrollStock);
        };
    });

    const handleScrollStock = (e) => {
        const fixsc = document.querySelector(".Stock-Market");
        const scrollTop = window.scrollY;
        if (fixsc != null) {
            scrollTop >= 150
                ? fixsc.classList.add("col-stickyStock")
                : fixsc.classList.remove("col-stickyStock");

            const bottom =
                e.target.scrollingElement.scrollHeight -
                e.target.scrollingElement.scrollTop < 2200

            // console.log(e);
            //console.log(bottom);
            if (bottom) {
                fixsc.classList.remove("col-stickyStock");
            }
        }
    }


    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    });

    const handleScroll = (e) => {
        const fixsc = document.querySelector(".Mutual-fund-keysection");
        const scrollTop = window.scrollY;
        if (fixsc != null) {
            scrollTop >= 150
                ? fixsc.classList.add("col-stickymf")
                : fixsc.classList.remove("col-stickymf");

            const bottom =
                e.target.scrollingElement.scrollHeight -
                e.target.scrollingElement.scrollTop < 2200

            // console.log(e);
            //console.log(bottom);
            if (bottom) {
                fixsc.classList.remove("col-stickymf");
            }
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", handleScrollIpo);
        return () => {
            window.removeEventListener("scroll", handleScrollIpo);
        };
    });

    const handleScrollIpo = (e) => {
        const fixsc = document.querySelector(".market-right-scIpo");
        const scrollTop = window.scrollY;
        if (fixsc != null) {
            scrollTop >= 150
                ? fixsc.classList.add("col-stickyIpo")
                : fixsc.classList.remove("col-stickyIpo");
            const bottom =
                e.target.scrollingElement.scrollHeight -
                e.target.scrollingElement.scrollTop < 2200;
            if (bottom) {
                fixsc.classList.remove("col-stickyIpo");
            }
        }
    }


    useEffect(() => {
        window.addEventListener("scroll", handleScrollFandO);
        return () => {
            window.removeEventListener("scroll", handleScrollFandO);
        };
    });

    const handleScrollFandO = (e) => {
        const fixsc = document.querySelector(".market-right-scFandO");
        const scrollTop = window.scrollY;
        if (fixsc != null) {
            scrollTop >= 150
                ? fixsc.classList.add("col-stickyFandO")
                : fixsc.classList.remove("col-stickyFandO");
            const bottom =
                e.target.scrollingElement.scrollHeight -
                e.target.scrollingElement.scrollTop < 2200;
            if (bottom) {
                fixsc.classList.remove("col-stickyFandO");
            }
        }
    }

    const trackData=(id)=>{
        const payloadData={
          "RelatedProspectId":id,
          "ActivityNote": "Market Event Tracker page visit",
          "mx_Custom_1": "Market Event Tracker",
          "mx_Custom_2": "Your Market Event Tracker Note",
          "mx_CustomObject_81":window.location.href
         }
         TrackApi(payloadData);
      }
      useEffect(()=>{
      
    if(cookies && cookies.RelatedProspectId){
      trackData(cookies.RelatedProspectId);
    }
        
      },[])
  
    return (
        <>
            <section className='market-sc'>
                <Container fluid className="btnTickerDiv">
                    <Container>
                        <Row>
                            <Col md={3} lg={3} xl={2} className="Attentionheading AttentionheadignText">
                                <button value="BSE" className={(valuebtn === "BSE") ? "active btnTicker" : 'btnTicker'} onClick={(event) => { setValueBtn(event.target.value) }}>BSE</button>
                                <button value="NSE" className={(valuebtn === "NSE") ? "active btnTicker" : 'btnTicker'} onClick={(event) => { setValueBtn(event.target.value) }}>NSE</button>
                            </Col>
                            <Col md={8} lg={9} xl={10}>
                                <marquee className="headingTicker" width="100%" direction="left">


                                    {(dataTicker[0] != undefined) ? <>
                                        <span>{format(parseISO(dataTicker[0].Tr_Date), 'dd-MMM-yyyy')}</span>&nbsp;
                                        <span>{(dataTicker[0].Tr_Date.split("T")[1] !== "00:00:00") ? dataTicker[0].Tr_Date.split("T")[1] : 'EOD'}</span>&nbsp;<span>|</span>&nbsp;</> : ''}
                                    {(dataTicker === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                    {dataTicker &&
                                        dataTicker.map(
                                            ({ Co_Name, Price, Price_Diff }) => (
                                                <div className="marqueeDiv">&nbsp;
                                                    <span> {Co_Name}</span>&nbsp;
                                                    <span>{Price && Price.toFixed(2)}</span>&nbsp;
                                                    <span className={Price_Diff > 0 ? "textGreen" : "textRed"}>{`( ${Price_Diff?Price_Diff.toFixed(2):""})`} </span>&nbsp; <span>|</span>&nbsp;
                                                </div>
                                            )
                                        )}
                                </marquee>
                            </Col>
                        </Row>
                    </Container>
                </Container>
                <Container>
                    <Row>
                        <Col sm={12}>
                            <div className='market-inner market-left slider-tab'>
                                {(activeTab != '') ?
                                    <Tabs defaultActiveKey={activeTab} transition={true} id="noanim-tab-example" onSelect={handleChange}>
                                        <Tab eventKey="eventTracker" title="Event Tracker">
                                            <Calendar />
                                        </Tab>
                                        <Tab eventKey="stocks" title="Stocks">
                                            <MarketEquity />
                                            <div className='market-left-sc'>
                                                <div className='market-inner-common'>
                                                    <div className='market-header'>
                                                        <h4>Index</h4>
                                                    </div>
                                                    {(dataIndex === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                    {loadingshowindex ? <div className="textcenter">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperclass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                                    <Slider className='market-slider' {...settings} >
                                                        {dataIndex &&
                                                            dataIndex.map(
                                                                ({ co_name, close_price, netchg, perchg, co_code }) => (
                                                                    <div className="each-equity">
                                                                        <div className="each-equity-inner">
                                                                            <div className="each-equity-beta">
                                                                                <div className="nameGroupIndex">
                                                                                    <h6>{co_name}</h6>
                                                                                </div>
                                                                                <div className="no-gutters">
                                                                                    <div className="col-4 compess">
                                                                                        <p> ₹ {close_price != null ? close_price : 0} </p>
                                                                                        <span className={netchg.toFixed(2) > 0 ? "textGreen" : "textRed"}> {netchg != null ? netchg.toFixed(2) : 0}</span>
                                                                                        <span className={perchg.toFixed(2) > 0 ? "textGreen" : "textRed"}> {perchg != null ? ("(" + perchg.toFixed(2) + "%)") : 0}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                    </Slider>
                                                </div>
                                                <div className='market-inner-common'>
                                                    <div className='market-header'>
                                                        <h4>Most Active</h4>
                                                    </div>
                                                    {(dataActive === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                    {loadingshowactive ? <div className="textcenter">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperclass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                                    <Slider className='market-slider' {...active} >
                                                        {dataActive &&
                                                            dataActive.map(
                                                                ({ lname, LastPrice, netchg, perchg, co_code }) => (
                                                                    <div className="each-equity">
                                                                        <div className="each-equity-inner">
                                                                            <div className="each-equity-beta">
                                                                                <div className="nameGroup">
                                                                                    <h6 onClick={routeChange} data-id={lname + '-' + co_code}>{lname}</h6>
                                                                                </div>
                                                                                <div className="no-gutters">
                                                                                    <div className="col-4 compess">
                                                                                        <p> ₹ {LastPrice != null ? LastPrice : 0} </p>
                                                                                        <span className={netchg.toFixed(2) > 0 ? "textGreen" : "textRed"}> {netchg != null ? netchg.toFixed(2) : 0}</span>
                                                                                        <span className={perchg.toFixed(2) > 0 ? "textGreen" : "textRed"}> {perchg != null ? ("(" + perchg.toFixed(2) + "%)") : 0}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                    </Slider>
                                                </div>
                                                <div className='market-inner-common'>
                                                    <div className='market-header'>
                                                        <h4>Top Gainers</h4>
                                                        <span className="more-info" onClick={() => { moreContent() }}>See More</span>
                                                    </div>
                                                    {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                    {loadingshowgainer ? <div className="textcenter">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperclass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                                    <Slider className='market-slider' {...gainer} >
                                                        {data &&
                                                            data.map(
                                                                ({ lname, close_price, netchg, perchg, co_code }) => (
                                                                    <div className="each-equity">
                                                                        <div className="each-equity-inner">
                                                                            <div className="each-equity-beta">
                                                                                <div className="nameGroup">
                                                                                    <h6 onClick={routeChange} data-id={lname + '-' + co_code}>{lname}</h6>
                                                                                </div>
                                                                                <div className="no-gutters">
                                                                                    <div className="col-4 compess">
                                                                                        <p> ₹ {close_price != null ? close_price : 0} </p>
                                                                                        <span className={netchg.toFixed(2) > 0 ? "textGreen" : "textRed"}> {netchg != null ? netchg.toFixed(2) : 0}</span>
                                                                                        <span className={perchg.toFixed(2) > 0 ? "textGreen" : "textRed"}> {perchg != null ? ("(" + perchg.toFixed(2) + "%)") : 0}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                    </Slider>
                                                </div>
                                                <div className='market-inner-common'>
                                                    <div className='market-header'>
                                                        <h4>Top Losers</h4>
                                                        <span className="more-info" onClick={() => { moreContent() }}>See More</span>
                                                    </div>
                                                    {(dataLoose === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                    {loadingshowloser ? <div className="textcenter">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperclassName="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                                    <Slider className='market-slider' {...loser} >
                                                        {dataLoose &&
                                                            dataLoose.map(
                                                                ({ lname, close_price, netchg, perchg, co_code }) => (
                                                                    <div className="each-equity">
                                                                        <div className="each-equity-inner">
                                                                            <div className="each-equity-beta">
                                                                                <div className="nameGroup">
                                                                                    <h6 onClick={routeChange} data-id={lname + '-' + co_code}>{lname}</h6>
                                                                                </div>
                                                                                <div className="no-gutters">
                                                                                    <div className="col-4 compess">
                                                                                        <p> ₹ {close_price != null ? close_price : 0} </p>
                                                                                        <span className={netchg.toFixed(2) > 0 ? "textGreen" : "textRed"}> {netchg != null ? netchg.toFixed(2) : 0}</span>
                                                                                        <span className={perchg.toFixed(2) > 0 ? "textGreen" : "textRed"}> {perchg != null ? ("(" + perchg.toFixed(2) + "%)") : 0}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                    </Slider>
                                                </div>
                                                <div className='market-inner-common'>
                                                    <div className='market-header'>
                                                        <h4>Stock in News</h4>
                                                        <span className="more-info" onClick={() => { moreNews() }}>News</span>
                                                    </div>
                                                    {(dataNews === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                    {loadingshownews ? <div className="textcenter">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperclassName="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                                    <Slider className='market-slider' {...news} >
                                                        {dataNews &&
                                                            dataNews.map(
                                                                ({ Heading, Date, Time }) => (
                                                                    <div className="each-equityNews">
                                                                        <div className="each-equity-inner">
                                                                            <div className="each-equity-beta">
                                                                                <div className="nameGroupNews">
                                                                                    <h6>{Heading}</h6>
                                                                                </div>
                                                                                <div className="no-gutters">
                                                                                    <div className="col-4 compess">
                                                                                        <p> {Date.split("T")[0]}</p>
                                                                                        <p> {Time}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                    </Slider>
                                                </div>
                                                <CorporateActMar />
                                                <div className='market-inner-common'>
                                                    <div className='market-header'>
                                                        <h4>Top by Market Cap</h4>
                                                        {/* <span>See More</span> */}
                                                    </div>
                                                    {loadingshowmarketcap ? <div className="textcenter">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperclassName="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                                    <div className='market-table table-responsive table-box'>
                                                        <table className='table'>
                                                            <thead>
                                                                <tr>
                                                                    <th className='text-left'>Company</th>
                                                                    <th className='text-right'>Market Price</th>
                                                                    <th className='text-right'>MCAP</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentTableData && currentTableData.map(
                                                                    ({ lname, Price, PriceDiff, change, co_code, MCAP }) => (
                                                                        <tr>
                                                                            <td className="text-left"><h6 className="marketCapHeading" onClick={routeChange} data-id={lname + '-' + co_code}>{lname}</h6></td>
                                                                            <td className="text-right"> ₹ {(Price != null) ? Price.toFixed(2) : 0}
                                                                                <p className={PriceDiff.toFixed(2) > 0 ? "textGreen" : "textRed"}> {PriceDiff != null ? PriceDiff.toFixed(2) : 0}
                                                                                    <span className={change.toFixed(2) > 0 ? "textGreen" : "textRed"}> {change != null ? ("(" + change.toFixed(2) + "%)") : 0}</span></p></td>
                                                                            <td className="text-right"> {(MCAP != null) ? MCAP.toFixed(2) : 0}</td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {(dataCap != null && dataCap != []) ?
                                                        <Pagination
                                                            className="pagination-bar_peer MarketCap"
                                                            currentPage={currentPage}
                                                            totalCount={(dataCap.length != null) ? dataCap.length : 0}
                                                            pageSize={PageSize}
                                                            onPageChange={page => setCurrentPage(page)}
                                                        /> : <p className="errorPeer"> No Data Found !!! </p>}
                                                </div>
                                            </div>
                                            <StockCard onScroll={handleScrollStock} />
                                        </Tab>
                                        <Tab eventKey="ipo" title="IPO">
                                            <MarketIPO />
                                            <div className='market-left-sc'>
                                                <IpoReturns />
                                                <Ipowatch />
                                                <Newlisting />
                                                <Bestperformers />
                                                <Basisofallotment />
                                                <Draftprospectus />
                                                <Iponews />
                                            </div>
                                            <IPOCard onScroll={handleScrollIpo} />
                                        </Tab>
                                        <Tab eventKey="mutualfund" title="Mutual Funds">
                                            <MarketMF />
                                            <div className='market-left-sc ipo-left'>
                                                <MFActivitiChart />
                                                <MfNav />
                                                <MfFundPerformance />
                                                <MfActivity />
                                                <MfTopHoldings />
                                                <MfWhatsInOut />
                                                <MfDividend />
                                                <MfFundProfile />
                                                <MfNewFundOffer />
                                                <MutualFundnews />
                                            </div>
                                            <MfCardNFO onScroll={handleScroll} />
                                        </Tab>
                                        <Tab eventKey="fando" title="F & O">
                                            <MarketFandO optionDrop="Derivative" />
                                            <div className='market-left-sc'>
                                                <FandOTodaysMarket />
                                                <FandOFIIStatistics />
                                                <FandOPutCallRatio />
                                                <FandOMostAttractiveContracts />
                                                <HighLowOpenIntrest />
                                                <OptionChains />
                                                <DerivativesNewsFandO />
                                            </div>
                                            <FandOCard onScroll={handleScrollFandO} />
                                        </Tab>
                                        <Tab eventKey="currency" title="Currency">
                                            <div className="currency">
                                                <section className="currency-hero theme-color hero-padding">
                                                    <div className="container">
                                                        <div className="row justify-content-between custom-height">
                                                            <div className="col-xl-6 col-lg-6 col-md-6">
                                                                <div className="text-box">
                                                                    <h2 className="title">Currency Trading with Moneysukh</h2>
                                                                    <p className="description">Start trading in the currency segment as it requires small margin, diversifies your portfolio and has healthy trading volumes.
                                                                        Start trading in currencies now.</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-4 col-lg-4 col-md-4 card-main">
                                                                <div className="card mx-auto">
                                                                    <h3 className="title text-center">Open Account</h3>
                                                                    <a className="card-submit text-center" href="https://ekyc.moneysukh.com:8443/index.aspx" target="_blank">Submit</a>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="describe-currency section-padding">
                                                    <div className="container">
                                                        <div className="row justify-content-between align-items-center">
                                                            <div className="col-xl-5 col-lg-6 col-md-5 ct-image-main">
                                                                <div className="ct-image">
                                                                    <img className="img-fluid" src={commoditybanner} alt="commoditybanner" />
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-6 col-md-6">
                                                                <div className="ct-text">
                                                                    <h2 className="title">What is Currency Trading?</h2>
                                                                    <p className="description">Currency trading, commonly known as forex trading, is the buying and selling of currency pairs in the foreign exchange market to earn profits through speculation.</p>
                                                                    <p className="description">Presently, the currency market, or the forex market, is one of the world's largest and most liquid markets, thereby recording a daily turnover of $ 2 trillion, with quick growth projections.</p>
                                                                    <p className="description">The primary factor that differentiates forex trading from other types of trading is its liquidity. The purchase and sale of one currency for another to take place simultaneously. This kind of trading is also known as 'Speculative forex trading.'</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <CurrencyTable />
                                                <section className="invest-currency section-padding">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-xl-12 col-lg-12 col-md-12 ">
                                                                <h2 className=" mx-auto title  text-center mb-5">5 reasons to invest in currencies with Moneysukh</h2>
                                                                <div className="invest-currency-card-container d-flex justify-content-center gap-5 flex-wrap">
                                                                    <div className="card invest-card" >
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={highliquidity} className="card-img-top" alt="highliquidity" />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">High Liquidity</h5>
                                                                            <p className="card-text">Trading in Forex tends to cater to highly liquid market. There are no hidden prices.</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card invest-card" >
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={tradeanywhere} className="card-img-top" alt="tradeanywhere" />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">Trade from anywhere</h5>
                                                                            <p className="card-text">Use web or mobile platform to trade in global currencies from your couch</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card invest-card" >
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={decisionicon} className="card-img-top" alt="decisionicon" />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">Make fast & precise decisions</h5>
                                                                            <p className="card-text">Study charts, understand market and place quick orders on FOREX market in real time</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card invest-card">
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={learnicon} className="card-img-top" alt="learnicon" />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">Learn</h5>
                                                                            <p className="card-text">Learn about currencies at Moneysukh</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card invest-card">
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={lowcost} className="card-img-top" alt="lowcost" />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">Low Cost</h5>
                                                                            <p className="card-text">Execute all orders at Flat fees of ₹20/order</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="sensibull section-padding">
                                                    <div className="container ">
                                                        <div className="row">
                                                            <h2 className="sensibull-title text-center mb-5"> Introducing Strategy Builder for currency options</h2>
                                                            <Tabs defaultActiveKey="easyoption" transition={true} id="noanim-tab-example">
                                                                <Tab eventKey="easyoption" title="Easy Option Strategy">
                                                                    <div className="sensibull-card-main  col-md-12 justify-content-between tab-pane fade show active" id="easy-option" >
                                                                        <div className="sensibull-card-container col-md-5">
                                                                            <div className=" sensibull-card sensibull-bgcolor ">
                                                                                <h2 className="sensibull-card-title mt-2 mb-3 text-center">Easy Option</h2>
                                                                                <p className="sensibull-card-content">Just predict up or down, and get limited
                                                                                    loss option strategies.</p>
                                                                                <h2 className="sensibull-number">01</h2>
                                                                            </div>
                                                                        </div>
                                                                        <div className="sensibull-card-img col-md-7 ">
                                                                            <span className="sensibull-mobilebackground"><img src={sensibull} alt="sensibull" /></span>
                                                                            <span className="sensibull-mobile"><img src={sensibullmblimg} alt="" /></span>
                                                                            <span className="sensibull-triangle-1"><img src={sensibull1} alt="sensibull1" /></span>
                                                                            <span className="sensibull-triangle-2"><img src={sensibull2} alt="sensibull2" /></span>
                                                                            <span className="sensibull-circle-1"><img src={sensibullcircle1} alt="sensibullcircle1" /></span>
                                                                            <span className="sensibull-circle-2"><img src={sensibullcircle2} alt="sensibullcircle2" /></span>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                                <Tab eventKey="traderecommandation" title="Create Your Own Strategies">
                                                                    <div className="sensibull-card-main col-md-12 justify-content-between tab-pane fade show active">
                                                                        <div className="sensibull-card-container col-md-5">
                                                                            <div className=" sensibull-card sensibull-bgcolor">
                                                                                <h2 className="sensibull-card-title mt-2 mb-3 text-center">Own Strategies</h2>
                                                                                <p className="sensibull-card-content">create  your own strategies  and trade simultaneously with no hustle and bustle</p>
                                                                                <h2 className="sensibull-number">02</h2>
                                                                            </div>
                                                                        </div>
                                                                        <div className="sensibull-card-img col-md-7 ">
                                                                            <span className="sensibull-mobilebackground"><img src={sensibull} alt="sensibull" /></span>
                                                                            <span className="sensibull-mobile"><img src={sensibullmblimg} alt="" /></span>
                                                                            <span className="sensibull-triangle-1"><img src={sensibull1} alt="sensibull1" /></span>
                                                                            <span className="sensibull-triangle-2"><img src={sensibull2} alt="sensibull2" /></span>
                                                                            <span className="sensibull-circle-1"><img src={sensibullcircle1} alt="sensibullcircle1" /></span>
                                                                            <span className="sensibull-circle-2"><img src={sensibullcircle2} alt="sensibullcircle2" /></span>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                            </Tabs>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="price-tags theme-color section-padding">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-xl-12 col-lg-12 col-md-12 ">
                                                                <h2 className="title blue-title mx-auto text-center mb-5">Enjoy best pricing with our Super Saver Packs</h2>
                                                                <div className="price-pack-container row justify-content-evenly col-xl-10 col-lg-10 col-md-10 mx-auto">
                                                                    <div className="price-pack green col-md-5 ">
                                                                        <div className="price-bg-logo p-0">
                                                                            <h3 className="price-title">Plan A</h3>
                                                                            <h2 className="price-title-big mb-1"></h2>
                                                                            <p className="price-description mb-3"></p>
                                                                            <div className="price-cashback price-details mb-3">
                                                                                <span></span>
                                                                                <p></p>
                                                                            </div>
                                                                            <div className="price-order price-details mb-3">
                                                                                <span>₹ 20</span>
                                                                                <p>Per order + Zero delivery Brokerage</p>
                                                                            </div>
                                                                            <div className="price-free price-details">
                                                                                <span></span>
                                                                                <p></p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="price-pack blue col-md-5 ">
                                                                        <div className="price-bg-logo p-0">
                                                                            <h3 className="price-title">Plan B</h3>
                                                                            <h2 className="price-title-big mb-1"></h2>
                                                                            <p className="price-description mb-3"></p>
                                                                            <div className="price-cashback price-details mb-3">
                                                                                <span></span>
                                                                                <p></p>
                                                                            </div>
                                                                            <div className="price-order price-details mb-3">
                                                                                <span>₹ 10</span>
                                                                                <p>Per order only ( No hidden charges)</p>
                                                                            </div>
                                                                            <div className="price-free price-details">
                                                                                <span></span>
                                                                                <p></p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="demat-account section-padding">
                                                    <div className="container">
                                                        <div className="row col-xl-12 col-lg-12 col-md-12">
                                                            <div className="col-xl-5 xol-lg-5 col-md-5 demat-img-main">
                                                                <div className="demat-img mb-4">
                                                                </div>
                                                                <h2 className="demat-title mb-5">Open your Currency Trading Account
                                                                    in 3 easy steps</h2>
                                                                <a className="demat-ctaf" href="https://ekyc.moneysukh.com:8443/index.aspx" target="_blank">Open Account</a>
                                                            </div>
                                                            <div className="col-xl-7 col-lg-7 col-md-7 demat-steps-container">
                                                                <div className="demat-step demat-step-left d-flex align-items-center gap-4 ms-5 mb-4">
                                                                    <div className="demat-step-img d-flex align-content-center justify-content-center">
                                                                        <img src={filldetail} alt="filldetail" />
                                                                    </div>
                                                                    <div className="demat-instruction">
                                                                        <h5 className="mb-2 instruction-title">Open your Account</h5>
                                                                        <p className="demat-description">
                                                                            Fill in your personal details required for account opening & select Derivatives segment while proceeding with your account opening journey.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="demat-step  d-flex align-items-center gap-4 mb-4">
                                                                    <div className="demat-step-img d-flex align-content-center justify-content-center">
                                                                        <img src={uploaddoc} alt="uploaddoc" />
                                                                    </div>
                                                                    <div className="demat-instruction">
                                                                        <h5 className="mb-2 instruction-title">Upload documents</h5>
                                                                        <p className="demat-description">
                                                                            In addition to the below mentioned list of documents, submit your income proof that is required for trading in Derivatives segment.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="demat-step demat-step-left d-flex align-items-center gap-4 ms-5">
                                                                    <div className="demat-step-img d-flex align-content-center justify-content-center">
                                                                        <img src={starttrading} alt="starttrading" />
                                                                    </div>
                                                                    <div className="demat-instruction">
                                                                        <h5 className="mb-2 instruction-title">Start currency trading</h5>
                                                                        <p className="demat-description">
                                                                            Post verification, your trading account will be activated and you can start investing in currencies.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="upload-documents theme-color section-padding">
                                                    <div className="container">
                                                        <div className="row justify-content-between align-items-center">
                                                            <div className="col-xl-5 col-lg-5 col-md-5">
                                                                <div className="upload-document-text">
                                                                    <h2 className="title blue-title mb-5">List of Documents to be uploaded</h2>
                                                                    <div className="documents-needed">
                                                                        <div className="id-proof proof mb-3">
                                                                            <div className="proof-title d-flex align-items-center">
                                                                                <span><img className="img-fluid" src={checkedcircle} alt="checkedcircle" /></span>
                                                                                <h5>ID Proof</h5>
                                                                            </div>
                                                                            <p className="proof-sample">Pan Card</p>
                                                                            <p className="proof-sample">Aadhaar Card</p>
                                                                        </div>
                                                                        <div className="id-proof proof mb-3">
                                                                            <div className="proof-title d-flex align-items-center">
                                                                                <span><img className="img-fluid" src={checkedcircle} alt="checkedcircle" /></span>
                                                                                <h5>Address Proof</h5>
                                                                            </div>
                                                                            <p className="proof-sample">Aadhaar Card / Passport</p>
                                                                        </div>
                                                                        <div className="id-proof proof mb-3">
                                                                            <div className="proof-title d-flex align-items-center">
                                                                                <span><img className="img-fluid" src={checkedcircle} alt="checkedcircle" /></span>
                                                                                <h5>Bank Details</h5>
                                                                            </div>
                                                                            <p className="proof-sample">Bank statement / Cheque / Passbook</p>
                                                                        </div>
                                                                        <div className="id-proof proof">
                                                                            <div className="proof-title d-flex align-items-center">
                                                                                <span><img className="img-fluid" src={checkedcircle} alt="checkedcircle" /></span>
                                                                                <h5>Signature Proof</h5>
                                                                            </div>
                                                                            <p className="proof-sample">Signature on blank white paper</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-6 col-md-6 upload-document-image-main">
                                                                <div className="upload-document-image">
                                                                    <img className="img-fluid" src={docimg} alt="docimg" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <CurrencyFAQ />
                                            </div>
                                        </Tab>
                                        <Tab eventKey="commodity" title="Commodity">
                                            <div className="commodity">
                                                <section className="commodity-hero theme-color hero-padding">
                                                    <div className="container">
                                                        <div className="row justify-content-between custom-height">
                                                            <div className="col-xl-6 col-lg-6 col-md-6">
                                                                <div className="text-box">
                                                                    <h2 className="title">Commodity Trading</h2>
                                                                    <p className="description">Start Trading in commodities now to diversify your portfolio. Mine your ideas and carve them into profits.</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-4 col-lg-4 col-md-4 card-main">
                                                                <div className="card mx-auto">
                                                                    <h3 className="title text-center">Open Account</h3>
                                                                    <a className="card-submit text-center" href="https://ekyc.moneysukh.com:8443/index.aspx" target="_blank">Submit</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="describe-commodity section-padding">
                                                    <div className="container">
                                                        <div className="row justify-content-between align-items-center">
                                                            <div className="col-xl-5 col-lg-6 col-md-5 ct-image-main">
                                                                <div className="ct-image">
                                                                    <img className="img-fluid" src={commoditybannerNew} alt="" />
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-6 col-md-6">
                                                                <div className="ct-text">
                                                                    <h2 className="title">What is Commodity Trading?</h2>
                                                                    <p className="description">Commodity trading is a commodity market where buying and selling of various commodities and their derivative products take place. These commodities are primarily categorized into metal, energy, livestock and meat, and agriculture.</p>
                                                                    <p className="description">For investors, the mcx commodity market from MCX (Multi Commodity Exchange of India Ltd), one of India's leading national commodity exchanges, is a way to diversify their portfolios beyond traditional securities.</p>
                                                                    <p className="description">Commodity market timings are unpredictable as they are affected by natural and manmade calamities. There are various ways to invest in commodities, such as commodity futures contracts, options, and extended traded funds (ETFs).</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <CommodityTable />
                                                <section className="invest-commodity section-padding">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-xl-12 col-lg-12 col-md-12 ">
                                                                <h2 className=" mx-auto title  text-center mb-5">Why invest in commodity market with Moneysukh?</h2>
                                                                <div className="invest-commodity-card-container d-flex justify-content-center gap-5 flex-wrap">
                                                                    <div className="card invest-card" >
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={diversification} className="card-img-top" alt="..." />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">Diversification</h5>
                                                                            <p className="card-text">Diversify & reduce your portfolio risk by investing with commodities.</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card invest-card" >
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={tradeanywhere} className="card-img-top" alt="..." />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">Trade from anywhere</h5>
                                                                            <p className="card-text">Use web or mobile platform to invest in commodities from your couch.</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card invest-card" >
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={descision} className="card-img-top" alt="..." />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">Make fast & precise decisions</h5>
                                                                            <p className="card-text">Study charts, understand market and place quick orders in commodity segment in real time.</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card invest-card">
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={learn} className="card-img-top" alt="..." />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">Learn</h5>
                                                                            <p className="card-text">Learn about commodities at Moneysukh.</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card invest-card">
                                                                        <div className="invest-card-img mb-3">
                                                                            <img src={lowcost} className="card-img-top" alt="..." />
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <h5 className="card-title mb-1">Low Cost</h5>
                                                                            <p className="card-text">Execute all orders at Flat fees of ₹20/order.</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="price-tags theme-color section-padding">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-xl-12 col-lg-12 col-md-12 ">
                                                                <h2 className="title blue-title mx-auto text-center mb-5">Enjoy best pricing with our Super Saver Packs</h2>
                                                                <div className="price-pack-container row justify-content-evenly col-xl-10 col-lg-10 col-md-10 mx-auto">
                                                                    <div className="price-pack green col-md-5 ">
                                                                        <div className="price-bg-logo p-0">
                                                                            <h3 className="price-title">Plan A</h3>
                                                                            <h2 className="price-title-big mb-1"></h2>
                                                                            <p className="price-description mb-3"></p>
                                                                            <div className="price-cashback price-details mb-3">
                                                                                <span></span>
                                                                                <p></p>
                                                                            </div>
                                                                            <div className="price-order price-details mb-3">
                                                                                <span>₹ 20</span>
                                                                                <p>Per order + Zero delivery Brokerage</p>
                                                                            </div>
                                                                            <div className="price-free price-details">
                                                                                <span></span>
                                                                                <p></p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="price-pack blue col-md-5 ">
                                                                        <div className="price-bg-logo p-0">
                                                                            <h3 className="price-title">Plan B</h3>
                                                                            <h2 className="price-title-big mb-1"></h2>
                                                                            <p className="price-description mb-3"></p>
                                                                            <div className="price-cashback price-details mb-3">
                                                                                <span></span>
                                                                                <p></p>
                                                                            </div>
                                                                            <div className="price-order price-details mb-3">
                                                                                <span>₹ 10</span>
                                                                                <p>Per order only ( No hidden charges)</p>
                                                                            </div>
                                                                            <div className="price-free price-details">
                                                                                <span></span>
                                                                                <p></p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="demat-account section-padding">
                                                    <div className="container">
                                                        <div className="row col-xl-12 col-lg-12 col-md-12">
                                                            <div className="col-xl-5 xol-lg-5 col-md-5 demat-img-main">
                                                                <h2 className="demat-title mb-5">Open your commodity trading account in 3 easy steps</h2>
                                                                <a className="demat-ctaf" href="https://ekyc.moneysukh.com:8443/index.aspx" target="_blank">Open Account</a>
                                                            </div>
                                                            <div className="col-xl-7 col-lg-7 col-md-7 demat-steps-container">
                                                                <div className="demat-step demat-step-left d-flex align-items-center gap-4 ms-5 mb-4">
                                                                    <div className="demat-step-img d-flex align-content-center justify-content-center">
                                                                        <img src={filldetail} alt="" />
                                                                    </div>
                                                                    <div className="demat-instruction">
                                                                        <h5 className="mb-2 instruction-title">fill in details</h5>
                                                                        <p className="demat-description">
                                                                            Fill in your personal details required for account opening & select Derivatives segment while proceeding with your account opening journey.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="demat-step  d-flex align-items-center gap-4 mb-4">
                                                                    <div className="demat-step-img d-flex align-content-center justify-content-center">
                                                                        <img src={uploaddoc} alt="" />
                                                                    </div>
                                                                    <div className="demat-instruction">
                                                                        <h5 className="mb-2 instruction-title">Upload documents</h5>
                                                                        <p className="demat-description">
                                                                            In addition to the below mentioned list of documents, submit your income proof that is required for trading in Derivatives segment.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="demat-step demat-step-left d-flex align-items-center gap-4 ms-5">
                                                                    <div className="demat-step-img d-flex align-content-center justify-content-center">
                                                                        <img src={starttrading} alt="" />
                                                                    </div>
                                                                    <div className="demat-instruction">
                                                                        <h5 className="mb-2 instruction-title">Start trading</h5>
                                                                        <p className="demat-description">
                                                                            Post verification, your trading account will be activated and you can start investing in commodities.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="upload-documents theme-color section-padding">
                                                    <div className="container">
                                                        <div className="row justify-content-between align-items-center">
                                                            <div className="col-xl-5 col-lg-5 col-md-5">
                                                                <div className="upload-document-text">
                                                                    <h2 className="title blue-title mb-5">List of Documents to be uploaded</h2>
                                                                    <div className="documents-needed">
                                                                        <div className="id-proof proof mb-3">
                                                                            <div className="proof-title d-flex align-items-center">
                                                                                <span><img className="img-fluid" src={checkedcircle} alt="" /></span>
                                                                                <h5>ID Proof</h5>
                                                                            </div>
                                                                            <p className="proof-sample">Pan Card</p>
                                                                            <p className="proof-sample">Aadhaar Card</p>
                                                                        </div>
                                                                        <div className="id-proof proof mb-3">
                                                                            <div className="proof-title d-flex align-items-center">
                                                                                <span><img className="img-fluid" src={checkedcircle} alt="" /></span>
                                                                                <h5>Address Proof</h5>
                                                                            </div>
                                                                            <p className="proof-sample">Aadhaar Card / Passport</p>
                                                                        </div>
                                                                        <div className="id-proof proof mb-3">
                                                                            <div className="proof-title d-flex align-items-center">
                                                                                <span><img className="img-fluid" src={checkedcircle} alt="" /></span>
                                                                                <h5>Bank Details</h5>
                                                                            </div>
                                                                            <p className="proof-sample">Bank statement / Cheque / Passbook</p>
                                                                        </div>
                                                                        <div className="id-proof proof">
                                                                            <div className="proof-title d-flex align-items-center">
                                                                                <span><img className="img-fluid" src={checkedcircle} alt="" /></span>
                                                                                <h5>Signature Proof</h5>
                                                                            </div>
                                                                            <p className="proof-sample">Signature on blank white paper</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-6 col-md-6 upload-document-image-main">
                                                                <div className="upload-document-image">
                                                                    <img className="img-fluid" src={docimg} alt="" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <section className="learn-commodity section-padding">
                                                    <div className="container">
                                                        <div className="row">
                                                            <h2 className=" mx-auto title blue-title text-center mb-5">Learn about Commodity Trading</h2>
                                                            <div className="course-details-main-container d-flex col-xl-12 col-lg-12 col-md-12 justify-content-between">
                                                                <div className="col-xl-5 col-lg-5 col-md-5 course-details-main-card">
                                                                    <img className="commoimg" src={commodity_image} alt="Commodity Image" />
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-6 course-details-text">
                                                                    <p className="mb-3">Commodity trading is a commodity market where buying and selling of various commodities and their derivative products take place. These commodities are primarily categorized into metal, energy, livestock and meat, and agriculture.</p>
                                                                    <p className="mb-3">For investors, the mcx commodity market from MCX (Multi Commodity Exchange of India Ltd), one of India's leading national commodity exchanges, is a way to diversify their portfolios beyond traditional securities.</p>
                                                                    <p className="mb-4">Commodity market timings are unpredictable as they are affected by natural and manmade calamities. There are various ways to invest in commodities, such as commodity futures contracts, options, and extended traded funds (ETFs).</p>
                                                                    <a className="expl" href="https://learn.moneysukh.com/category/commodity-currency/" target="_blank">Explore More</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                <CommoditiesFAQ />
                                            </div>
                                        </Tab>
                                        <Tab eventKey="etf" title="ETF">
                                           <ETFProduct />
                                        </Tab>
                                        <Tab eventKey="sgb" title="SGB">
                                            <SGBPage />
                                        </Tab>
                                    </Tabs> : ''}
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>
        </>
    );
}

export default Market;